module.exports = __webpack_public_path__ + "static/audience-hotels-f2b91d3652bba94a68966152bd39980f.jpg";